export default __webpack_public_path__ + "static/media/My-Cart.c8ef1b42.jpg";